var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm._v(" "),
      _vm.mechanismDialogVisible
        ? _c(
            "div",
            { staticClass: "breadcrumb-container" },
            [
              _c("tree-select", {
                staticClass: "currentInstitution",
                attrs: {
                  props: _vm.defaultProps,
                  options: _vm.depts,
                  value: _vm.deptName - 0,
                },
                on: { getValue: _vm.changeDept },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile" ? void 0 : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.noticeContent > 0 ? "bellIcon" : "",
              attrs: {
                id: "iconBellIcon",
                "data-content-after": _vm.noticeContent,
              },
            },
            [
              _c("svg-icon", {
                attrs: { "icon-class": "bell" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.notification.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: " right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("i", { staticClass: "el-icon-user" }),
                    _vm._v(
                      "\n          " + _vm._s(_vm.user.realName) + "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "span",
                    { on: { click: _vm.openUserInfo } },
                    [_c("el-dropdown-item", [_vm._v(" 用户信息 ")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["user:resetpassword"],
                          expression: "['user:resetpassword']",
                        },
                      ],
                      on: { click: _vm.changePassword },
                    },
                    [_c("el-dropdown-item", [_vm._v(" 修改密码 ")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { on: { click: _vm.open } },
                    [_c("el-dropdown-item", [_vm._v(" 退出 ")])],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("messageBox", {
        ref: "messageBox",
        attrs: { "customer-type": _vm.customerType },
        on: { messageContent: _vm.messageContent },
      }),
      _vm._v(" "),
      _c("reminder", {
        ref: "reminder",
        attrs: {
          "data-list-array": _vm.messageDataList,
          "customer-type": _vm.customerType,
        },
      }),
      _vm._v(" "),
      _c("modifyTheUserPassword", { ref: "modifyTheUserPassword" }),
      _vm._v(" "),
      _c("user-info-dialog", { ref: "userInfoDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }